module.exports = __webpack_public_path__ + "static/media/VLineSafesSerialandModelNumbers.e324e2ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/VLineSafesSerialandModelNumbers.jpg
// module id = 1282
// module chunks = 0